// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/search/search_session.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_annotations } from "../core/annotations_pb";
import { file_proto_model_core_paging } from "../core/paging_pb";
import { file_proto_model_core_sort } from "../core/sort_pb";
import { file_proto_model_entity_place } from "../entity/place_pb";
import { file_proto_model_feature_activity_activity_search } from "../feature/activity/activity_search_pb";
import { file_proto_model_feature_hotel_hotel_search } from "../feature/hotel/hotel_search_pb";
import { file_proto_model_feature_restaurant_restaurant_search } from "../feature/restaurant/restaurant_search_pb";
import { file_proto_model_feature_transportation_transportation_search } from "../feature/transportation/transportation_search_pb";
import { file_proto_model_search_place_search } from "./place_search_pb";
import { file_proto_model_search_search_domain } from "./search_domain_pb";
import { file_proto_model_search_search_result } from "./search_result_pb";
import { file_proto_model_system_errors } from "../system/errors_pb";

/**
 * Describes the file proto/model/search/search_session.proto.
 */
export const file_proto_model_search_search_session = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_proto_model_core_annotations, file_proto_model_core_paging, file_proto_model_core_sort, file_proto_model_entity_place, file_proto_model_feature_activity_activity_search, file_proto_model_feature_hotel_hotel_search, file_proto_model_feature_restaurant_restaurant_search, file_proto_model_feature_transportation_transportation_search, file_proto_model_search_place_search, file_proto_model_search_search_domain, file_proto_model_search_search_result, file_proto_model_system_errors]);

/**
 * Describes the message carmen.SearchSession.
 * Use `create(SearchSessionSchema)` to create a new message.
 */
export const SearchSessionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_search_session, 0);

/**
 * Describes the message carmen.SearchSession.Display.
 * Use `create(SearchSession_DisplaySchema)` to create a new message.
 */
export const SearchSession_DisplaySchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_search_session, 0, 0);

/**
 * Describes the message carmen.SearchSession.DetectedIntent.
 * Use `create(SearchSession_DetectedIntentSchema)` to create a new message.
 */
export const SearchSession_DetectedIntentSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_search_session, 0, 1);

/**
 * Describes the message carmen.SearchSession.Metadata.
 * Use `create(SearchSession_MetadataSchema)` to create a new message.
 */
export const SearchSession_MetadataSchema = /*@__PURE__*/
  messageDesc(file_proto_model_search_search_session, 0, 2);

/**
 * Describes the enum carmen.SearchSession.Origin.
 */
export const SearchSession_OriginSchema = /*@__PURE__*/
  enumDesc(file_proto_model_search_search_session, 0, 0);

/**
 * @generated from enum carmen.SearchSession.Origin
 */
export const SearchSession_Origin = /*@__PURE__*/
  tsEnum(SearchSession_OriginSchema);

/**
 * Describes the enum carmen.SearchSession.State.
 */
export const SearchSession_StateSchema = /*@__PURE__*/
  enumDesc(file_proto_model_search_search_session, 0, 1);

/**
 * @generated from enum carmen.SearchSession.State
 */
export const SearchSession_State = /*@__PURE__*/
  tsEnum(SearchSession_StateSchema);

/**
 * Describes the enum carmen.SearchSession.Mode.
 */
export const SearchSession_ModeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_search_search_session, 0, 2);

/**
 * Search mode determines how queries are processed
 *
 * @generated from enum carmen.SearchSession.Mode
 */
export const SearchSession_Mode = /*@__PURE__*/
  tsEnum(SearchSession_ModeSchema);

